import { useQuery, useMutation, ApolloError, OperationVariables } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const useGraphQLQuery = <T = any, V extends OperationVariables = OperationVariables>(
  query: DocumentNode,
  variables?: V,
  options?: {
    skip?: boolean;
    fetchPolicy?:
      | 'cache-first'
      | 'network-only'
      | 'cache-only'
      | 'no-cache'
      | 'standby'
      | 'cache-and-network';
    lazy?: boolean;
  }
) => {
  const { loading, error, data, refetch, fetchMore } = useQuery<T, V>(query, {
    variables,
    skip: options?.lazy === true || options?.skip,
    fetchPolicy: options?.fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  return {
    loading,
    error,
    data,
    refetch,
    fetchMore,
  };
};

export const useGraphQLMutation = <T = any, V extends OperationVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: {
    onCompleted?: (data: T) => void;
    onError?: (error: ApolloError) => void;
    refetchQueries?: DocumentNode[] | string[];
  }
) => {
  const [mutate, { loading, error, data }] = useMutation<T, V>(mutation, {
    onCompleted: options?.onCompleted,
    onError: options?.onError,
    refetchQueries: options?.refetchQueries as any,
  });

  return {
    mutate,
    loading,
    error,
    data,
  };
};
